module.exports = __webpack_public_path__ + "static/logo-black-11114b40f06fe2f8d7d938f750ea2b01.svg";